import React from "react";
import { Stack } from "@mui/material";

import { StyledSkeleton } from "../../pages/PartDetails/styles";

const sx = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "15px",
};

const RoutingTableSkeleton = () => {
  return (
    <Stack gap="15px" height="100%">
      <Stack gap="2px">
        {Array.from(new Array(8)).map((_, rowIndex) => (
          <StyledSkeleton key={rowIndex} variant="rounded" height={33.83} />
        ))}
      </Stack>
    </Stack>
  );
};

export default RoutingTableSkeleton;
